"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (action) {
  return "@spp/core-navigation/" + action;
};
//# sourceMappingURL=actionNamePrefixer.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/lib/cjs/redux/actionNamePrefixer.js
 ** module id = 622
 ** module chunks = 1
 **/